import { render, staticRenderFns } from "./active-button.vue?vue&type=template&id=9f212756"
import script from "./active-button.vue?vue&type=script&lang=js"
export * from "./active-button.vue?vue&type=script&lang=js"
import style0 from "./active-button.vue?vue&type=style&index=0&id=9f212756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports